import type { DemandPointModel } from '@/shared/generated'

export type DemandBarRow = {
	date_on: string
	units: number
	fill: string
	fillOpacity: number
}

export const buildDemandBarRows = (
	points: DemandPointModel[],
	windowStartIndex?: number
): DemandBarRow[] =>
	points.map((point, index) => {
		const inWindow = windowStartIndex !== undefined && index >= windowStartIndex

		if (point.units === 0 || !inWindow) {
			return {
				date_on: point.date_on,
				units: point.units,
				fill: 'var(--color-neutral-500)',
				fillOpacity: 0.5,
			}
		}

		return {
			date_on: point.date_on,
			units: point.units,
			fill: 'var(--color-neutral-700)',
			fillOpacity: 1,
		}
	})
